/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:0803852a-11d7-4fd7-9e90-71db29ddef5d",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_AcYrcdFGX",
    "aws_user_pools_web_client_id": "6d8v83sjubahcbcdrehvdp17ft",
};


export default awsmobile;
